<template>
    <div class="vipt">
        <div class="screen">
            <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
        </div>
        <div class="search">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../assets/secree.png" alt="">
            </div>
            <div>
                <input type="text" placeholder="关键字搜索" v-model="keyword" @keyup.enter="seach">
            </div>
        </div>
        <div class="calendar">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="" end-placeholder="" @change="changedata" format="MM.DD" :clearable="true" />
        </div>
    </div>
    <div class="vipporpe" v-loading="loading">
        <table>
            <thead>
                <tr>
                    <th>
                        <!-- <el-checkbox /> -->
                    </th>
                    <th>商铺名称</th>
                    <th>商铺类型</th>
                    <th>商铺评价</th>
                    <th>总销量（件）</th>
                    <th>总关注（人）</th>
                    <th>总商品（件）</th>
                    <th>注册时间</th>
                    <th>状态</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in StoreDatalist" :key="index" style="cursor: pointer;"
                    @click="gomessage(item.ucomid)">
                    <td @click.stop>
                        <el-checkbox />
                    </td>
                    <td>
                        <div class="stroeh">
                            <div class="header">
                                <img :src="images(item.ucomlogo)" alt="">
                            </div>
                            <div class="storename">
                                <div>{{ item.ucomname }}</div>
                                <div class="stid">ID: {{ item.ucomid }}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        {{ item.industry }}
                    </td>
                    <td>
                        <el-rate v-model="item.comprehensiveScore" disabled show-score text-color="#FF2928"
                            :colors="colors" score-template="{value}" />
                    </td>
                    <td>
                        {{ item.salesNum }}
                    </td>
                    <td>
                        {{ item.followCount }}

                    </td>
                    <td>
                        {{ item.productCount > 0 ? item.productCount : 0 }}

                    </td>
                    <td>
                        {{ datahuan(item.ucomregdate) }}
                    </td>
                    <td @click="gomessage(item.ucomid)" style="cursor: pointer;">
                        <div :class="item.bannedStatus == 0 ? 'statea' : 'state2'">
                            {{ item.bannedStatus == 0 ? '未封禁' : '已封禁' }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div style=" height: 70px;"></div>

    </div>
    <div class="pagechoose">
        显示结果：
        <div class="pagees">

            <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

        </div>

    </div>
    <Noshu :disabled="loading" :lengths="StoreDatalist.length" ></Noshu>

    <div class="example-pagination-block" :style="{ 'display': wordKey.length >= 1 ? 'none' : '' }">
        <el-pagination class="example-pagination-block" background v-model:current-page="current"
            layout="prev, pager, next" :pager-count="5" :total="total" @current-change="changepige"
            :disabled="loading" />
    </div>
    <div class="example-pagination-iskey" :style="{ 'display': wordKey.length >= 1 ? '' : 'none' }">
        <el-pagination class="example-pagination-iskey" background v-model:current-page="current"
            layout="prev, pager, next" :pager-count="5" :total="123" @current-change="changepige" :disabled="loading" />
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import storeapi from '@/api/store'
import Noshu from '@/components/Noshu.vue'

const emit = defineEmits(['totallist'])
let current = ref(1)
let keyword = ref('')
let wordKey = ref('')
let startDate = ref('')
let endDate = ref('')
let StoreDatalist = ref([])
let total = ref(0)
let keywordType = ref('1')
onMounted(() => {
    storelist()
})
let loading = ref(false)

let pageSize = ref(5)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    storelist()
}

const storelist = async () => {
    loading.value = true

    try {
        let data
        if (startDate.value.length > 0) {
            data = {
                "endDate": endDate.value,
                "startDate": startDate.value,
                "keyword": keyword.value,
                "keywordType": keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                },
            }
        } else {
            data = {
                "keyword": keyword.value,
                "keywordType": keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                }
            }
        }

        const res = await storeapi.postStoreData(data)
        if (res.data) {
            StoreDatalist.value = res.data.records
            emit('totallist', res.data.total)

            total.value = (Math.ceil(res.data.total / pageSize.value))
            console.log('total', total.value)

            console.log('已审核店铺列表', StoreDatalist.value)
            loading.value = false
        } else {
            loading.value = false

        }

    } catch (error) {
        // 处理错误
        console.log(error)
    }
}


//跳转页面
const changepige = (val) => {
    console.log(val)
    current.val = val
    storelist()
}
//搜索
const seach = () => {
    startDate.value = ''
    endDate.value = ''
    wordKey.value = keyword.value
    current.value = 1
    storelist()
}

const router = useRouter()
const gomessage = (storeId) => {
    router.push({
        path: '/home/shopDetails',
        query: { storeId: storeId }
    })
}
const value = ref([])
const value2 = ref(5)
const colors = ref(['#FF2928', '#FF2928', '#FF2928'])
const options = reactive([

    {
        value: 1,
        label: '店铺',
    }

])
const handleChange = (value) => {
    console.log(value[0])
    keywordType.value = value[0]

}
let nowdata = new Date()
let nextdata = new Date()
const choosedata = ref([nowdata, nextdata])
const changedata = (e) => {
    if (e == null) {
        e = ['', '']
    }
    console.log(e)
    startDate.value = datahuan(e[0])
    endDate.value = datahuan(e[1])
    console.log(startDate.value)
    console.log(endDate.value)
    storelist()
}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补零
        const day = date.getDate().toString().padStart(2, '0'); // 补零
        return `${year}-${month}-${day}`;
    } else {
        return ''
    }

}
const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../assets/shop/morentx.png')
    }

}

</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 100%;
    height: 100%;

    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;

    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}



::v-deep .el-checkbox__input {
    height: 20px;

    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }

    .el-checkbox__inner {
        &::after {
            top: 4px;
            left: 8px;
        }

    }
}

::v-deep .example-pagination-block {
    position: absolute;
    bottom: 15px;
    right: 34px;



    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }


}


::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none !important;
    }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}

.pagechoose {
    position: absolute;
    bottom: 0px;
    left: 14px;
    width: 100%;
    height: 70px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .pagees {
        width: 71px;
        height: 40px;
        border: 1px solid #EEEFF2;
        border-radius: 8px;
        padding: 8px 0 0 0px;
        box-sizing: border-box;

        input {
            width: 80%;


        }
    }
}

.vipt {
    padding-top: 9px;
    margin-left: 15px;
    display: flex;

    .screen {
        width: 168px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 8px;
        margin-right: 24px;
    }

    .search {
        width: 412px;
        height: 48px;
        margin-right: 14px;
        background: #FAFAFA;
        // box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #FAFAFA;

        }

        ::placeholder {
            font-weight: 400;
            font-size: 14px;
            color: #7D8592;
        }

    }

    .calendar {
        width: 168px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
    }

}

.vipporpe {
    width: 100%;
    // padding-left: 15px;
    box-sizing: border-box;




    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;
            border-bottom: 1px solid #EEEFF2;
            height: 46px;

            th {
                vertical-align: middle;


            }

            th:first-child {
                padding-left: 15px;

            }

            .states {
                text-align: center;
            }
        }

        tbody {
            tr {
                height: 96px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                border-bottom: 1px solid #EEEFF2;

                td:first-child {
                    padding-left: 15px;

                }

                td:nth-child(2) {
                    .stroeh {
                        display: flex;

                        .header {
                            width: 56px;
                            height: 56px;
                            background-color: #718096;
                            border-radius: 8px;
                            margin-right: 24px;
                            overflow: hidden;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .storename {
                            font-size: 16px;

                            font-weight: 400;
                            color: #111827;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .stid {
                                font-size: 14px;
                                font-family: HelveticaNeue;
                                color: #718096;
                            }
                        }

                    }
                }

                td:last-child {

                    color: #1787FF;

                }

                td {

                    vertical-align: middle;

                    .statea {
                        width: 66px;
                        height: 42px;
                        background: #EBF3FF;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1787FF;
                    }

                    .state2 {
                        width: 66px;
                        height: 36px;
                        background: rgb(252, 241, 231);
                        border-radius: 4px;
                        text-align: center;
                        line-height: 36px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgb(243, 182, 133);
                    }


                }


            }

            tr:hover {
                background-color: #f3f3f3;
            }
        }

    }
}
</style>